var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "el-dialog",
        {
          staticClass: "dialog",
          attrs: {
            title: "生成报价单",
            visible: _vm.quotationDialog,
            width: _vm.getIsMobile ? "100%" : "75%",
            "close-on-click-modal": false,
            "close-on-press-escape": false,
            "append-to-body": true,
          },
          on: {
            "update:visible": function ($event) {
              _vm.quotationDialog = $event
            },
            close: _vm.handleCloseQuotation,
          },
        },
        [
          _c(
            "el-table",
            {
              staticStyle: { position: "relative" },
              attrs: { data: _vm.list, border: "" },
            },
            [
              _c("el-table-column", {
                attrs: { label: "序号", prop: "" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [_vm._v(" " + _vm._s(scope.$index + 1) + " ")]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: { label: "型号", prop: "xhname" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (ref) {
                      var row = ref.row
                      return [
                        !row.editable
                          ? _c("span", [_vm._v(_vm._s(row.xhname))])
                          : _c("el-input", {
                              attrs: {
                                type: "text",
                                placeholder: "请输入型号",
                              },
                              model: {
                                value: row.xhname,
                                callback: function ($$v) {
                                  _vm.$set(row, "xhname", $$v)
                                },
                                expression: "row.xhname",
                              },
                            }),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: { label: "品牌", prop: "source" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (ref) {
                      var row = ref.row
                      return [
                        !row.editable
                          ? _c("span", [_vm._v(_vm._s(row.source))])
                          : _c("el-input", {
                              attrs: {
                                type: "text",
                                placeholder: "请输入品牌",
                              },
                              model: {
                                value: row.source,
                                callback: function ($$v) {
                                  _vm.$set(row, "source", $$v)
                                },
                                expression: "row.source",
                              },
                            }),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: { label: "数量", prop: "num" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (ref) {
                      var row = ref.row
                      var $index = ref.$index
                      return [
                        _c("el-input", {
                          attrs: { type: "text", placeholder: "请输入数量" },
                          on: {
                            input: function ($event) {
                              return _vm.validateNum(row, $index)
                            },
                          },
                          model: {
                            value: row.num,
                            callback: function ($$v) {
                              _vm.$set(row, "num", _vm._n($$v))
                            },
                            expression: "row.num",
                          },
                        }),
                        _vm.errors[$index]
                          ? _c("span", { staticClass: "error-text" }, [
                              _vm._v("数量为必填项"),
                            ])
                          : _vm._e(),
                        row.channel === 2 && _vm.numErrors[$index]
                          ? _c("span", { staticClass: "warning-text" }, [
                              _vm._v(_vm._s("库存数量：" + row.number)),
                            ])
                          : _vm._e(),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: { label: "单价", prop: "price" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (ref) {
                      var row = ref.row
                      return [
                        _c("el-input", {
                          attrs: { type: "text", placeholder: "请输入单价" },
                          model: {
                            value: row.price,
                            callback: function ($$v) {
                              _vm.$set(row, "price", $$v)
                            },
                            expression: "row.price",
                          },
                        }),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: { label: "总价", prop: "zprice" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (ref) {
                      var row = ref.row
                      return [
                        _c("span", [
                          _vm._v(
                            _vm._s(
                              isFinite(row.num * row.price)
                                ? (row.num * row.price).toFixed(2)
                                : ""
                            )
                          ),
                        ]),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: { label: "货期", prop: "hq" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (ref) {
                      var row = ref.row
                      return [
                        _c("el-input", {
                          attrs: { type: "text", placeholder: "请输入货期" },
                          model: {
                            value: row.hq,
                            callback: function ($$v) {
                              _vm.$set(row, "hq", $$v)
                            },
                            expression: "row.hq",
                          },
                        }),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: { label: "备注", prop: "bz" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (ref) {
                      var row = ref.row
                      return [
                        _c("el-input", {
                          attrs: { type: "text", placeholder: "请输入备注" },
                          model: {
                            value: row.bz,
                            callback: function ($$v) {
                              _vm.$set(row, "bz", $$v)
                            },
                            expression: "row.bz",
                          },
                        }),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: { label: "操作" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (ref) {
                      var row = ref.row
                      var $index = ref.$index
                      return [
                        _c(
                          "el-button",
                          {
                            staticClass: "el-icon-delete",
                            attrs: { type: "danger", size: "small" },
                            on: {
                              click: function ($event) {
                                return _vm.handleDelete($index)
                              },
                            },
                          },
                          [_vm._v("删除")]
                        ),
                      ]
                    },
                  },
                ]),
              }),
            ],
            1
          ),
          _c("el-tag", { staticClass: "contract-tag" }, [
            _c(
              "span",
              { staticClass: "contract-link", attrs: { type: "primary" } },
              [_vm._v("总价：" + _vm._s(_vm.totalAmount))]
            ),
          ]),
          _c(
            "el-button",
            {
              staticClass: "el-icon-plus",
              attrs: { type: "primary", size: "small" },
              on: { click: _vm.addModel },
            },
            [_vm._v("增加型号")]
          ),
          _c(
            "el-button",
            {
              staticStyle: { "margin-top": "8px" },
              attrs: { type: "warning" },
              on: { click: _vm.openCompany },
            },
            [_vm._v("选择报价公司")]
          ),
          _vm.showInfo
            ? _c(
                "el-card",
                { staticStyle: { "margin-top": "10px" } },
                [
                  _c("Info", {
                    ref: "infoRef",
                    attrs: {
                      companyInfo: _vm.companyInfo,
                      allInfo: _vm.allInfo,
                    },
                    on: {
                      handleContact: _vm.getContact,
                      handleFlag: _vm.handleFlag,
                    },
                  }),
                ],
                1
              )
            : _vm._e(),
          _c(
            "el-form",
            { staticClass: "form", attrs: { model: _vm.form } },
            [
              _c(
                "el-form-item",
                { attrs: { label: "是否含税", prop: "kpzt" } },
                [
                  _c(
                    "el-radio-group",
                    {
                      model: {
                        value: _vm.form.kpzt,
                        callback: function ($$v) {
                          _vm.$set(_vm.form, "kpzt", $$v)
                        },
                        expression: "form.kpzt",
                      },
                    },
                    [
                      _c("el-radio", { attrs: { label: 0 } }, [_vm._v("含税")]),
                      _c("el-radio", { attrs: { label: 2 } }, [_vm._v("未税")]),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _vm.showInfo
            ? _c(
                "div",
                [
                  _c(
                    "el-button",
                    {
                      staticStyle: { "margin-top": "8px" },
                      attrs: { type: "primary" },
                      on: { click: _vm.printQuotation },
                    },
                    [_vm._v("生成报价单")]
                  ),
                  _c(
                    "el-button",
                    {
                      staticStyle: { "margin-top": "8px" },
                      attrs: { type: "primary" },
                      on: { click: _vm.printContract },
                    },
                    [_vm._v("生成合同")]
                  ),
                  _c(
                    "el-button",
                    {
                      staticStyle: { "margin-top": "8px" },
                      on: { click: _vm.handleCloseQuotation },
                    },
                    [_vm._v("取消")]
                  ),
                ],
                1
              )
            : _vm._e(),
        ],
        1
      ),
      _c(
        "el-dialog",
        {
          attrs: {
            title: "选择报价公司",
            visible: _vm.showCompany,
            width: _vm.getIsMobile ? "100%" : "70%",
            "close-on-click-modal": false,
            "close-on-press-escape": false,
            "before-close": _vm.handleClose,
            "append-to-body": false,
          },
          on: {
            "update:visible": function ($event) {
              _vm.showCompany = $event
            },
          },
        },
        [_c("QuotationCompany", { on: { selectedCompany: _vm.getCompany } })],
        1
      ),
      _c(
        "el-dialog",
        {
          attrs: {
            title: "选择公司联系人",
            visible: _vm.showCompanyContact,
            width: _vm.getIsMobile ? "100%" : "80%",
            "close-on-click-modal": false,
            "close-on-press-escape": false,
            "before-close": _vm.handleCompanyContactClose,
            "append-to-body": false,
          },
          on: {
            "update:visible": function ($event) {
              _vm.showCompanyContact = $event
            },
          },
        },
        [
          _vm.showCompanyContact
            ? _c("CompanyContacts", {
                ref: "contactRef",
                attrs: { data: _vm.companyContact },
                on: {
                  quotationContact: _vm.getSelectContacts,
                  getFirstContact: _vm.getFirstContact,
                },
              })
            : _vm._e(),
        ],
        1
      ),
      _vm.flag
        ? _c("CompanyContacts", {
            ref: "contactRef",
            attrs: { data: _vm.companyContact },
            on: {
              quotationContact: _vm.getSelectContacts,
              getFirstContact: _vm.getFirstContact,
            },
          })
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }